import React from 'react'
import { TGeneralActivity } from '../../store/admin/statistics/generalActivity/types'
import { TViewedItemsActivity, TViewedItemsActivityChild } from '../../store/admin/statistics/viewedItemsActivity/types'
import { Arrow } from '../../svg/Arrow'
import { TFavoritesActivityChild } from '../../store/admin/statistics/favoritesActivity/types'
import { getDate } from '../helpers'

export const getViewedItemsActivityParsed = (
  data: TViewedItemsActivity[],
  childIndex: number[],
  callBack: (idItem: number) => void,
  idTender: number
) => {
  return data.map((item) => {
    const isOpened = childIndex.some((index) => index === +`${idTender}${item.item_id}`)
    const action = (
      <button type='button' className='flex' onClick={() => callBack(isOpened ? -1 : item.item_id)}>
        View
        <div className={`inline-block transform transition-transform ${isOpened && 'rotate-180'}`}>
          <Arrow />
        </div>
      </button>
    )
    return {
      id: +`${idTender}${item.item_id}`,

      stock_number: item.stock_number,
      title: item.title,
      count_of_unique_user_views: item.count_of_unique_user_views,
      action,
    }
  })
}

export const getViewedItemsActivityChildParsed = (data: TViewedItemsActivityChild[]) => {
  return data.map((user) => {
    return {
      email: user.email,
      company: user.company_title,
      count_views: user.count_views,
    }
  })
}

export const getGeneralActivityParsed = (data: TGeneralActivity[], idTender: number) => {
  return data.map((item) => {
    return {
      id: +`${idTender}${item.item_id}`,

      stock_number: item.stock_number,
      title: item.title,
      count_of_unique_user_views: item.count_of_unique_user_views,
      count_of_wishlists: item.count_of_wishlists,
      count_of_bids: item.count_of_bids,
      is_winning: !!item.buy_bid,
    }
  })
}

export const getFavoritesActivityParsed = (
  data: TGeneralActivity[],
  childIndex: number[],
  callBack: (idItem: number) => void,
  idTender: number
) => {
  return data.map((item) => {
    const isOpened = childIndex.some((index) => index === +`${idTender}${item.item_id}`)
    const action = (
      <button type='button' className='flex' onClick={() => callBack(isOpened ? -1 : item.item_id)}>
        View
        <div className={`inline-block transform transition-transform ${isOpened && 'rotate-180'}`}>
          <Arrow />
        </div>
      </button>
    )

    return {
      id: +`${idTender}${item.item_id}`,

      stock_number: item.stock_number,
      title: item.title,
      count_of_wishlists: item.count_of_wishlists,
      action,
    }
  })
}

export const getFavoritesActivityChildParsed = (data: TFavoritesActivityChild[]) => {
  return data.map((user) => {
    return {
      email: user.email,
      company: user.company_title,
      timestamp: user.wishlist_created_at ? getDate(user.wishlist_created_at) : '---',
    }
  })
}
